
const digest = '2e1d4dd61f93c0e6d79cf423939dd2918a35a7f4aa20f446981532489205f733';
const classes = {"child":"_child_1czps_1"};
const css = `._child_1czps_1 {
  margin: 12px 24px;
  position: relative;
}
._child_1czps_1::before {
  content: "";
  width: 10px;
  height: 11px;
  border-left: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  position: absolute;
  left: -14px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  